namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_html extends $.$shm_hitalama_map_widget_float_ai_request_html {

		prompt(): string {
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt_html.md' ) )
			return text.replace( '{{Описание приложения}}', this.text() )
		}
		
		paste() {

			const Widget = this.Widget()

			const text = $mol_wire_sync(navigator.clipboard).readText()
			const obj = JSON.parse( text ) as AI_answer
			const old_names = this.Widget().map().Widgets_list()?.remote_list().flatMap( ( b: $shm_hitalama_map_widget ) => b.type() == 'code_js' ? [b.title()] : [] ) ?? []
			const vers = createNameVersions( old_names, obj.getFunctions.map( f => f[0] ) )

			obj.getFunctions.forEach( f => {
				for (const name in vers) {
					const v = vers[name]
					if( v == 1 ) continue
					f[0] = f[0] == name ? name+v : f[0]
					f[1] = f[1].replaceAll(`'${name}'`, `${name+v}`)
					obj.mainScriptBody = obj.mainScriptBody.replaceAll(`'${name}'`, `${name+v}`)
				}
			} )

			const gap = 25
			// const md_height = 500
			// const md = Widget.map().widget_add( 'text_md', [Widget.left(), Widget.top()+Widget.height()+gap ], 600, md_height )
			// md?.title( `Ответ ${(new $mol_time_moment).toString('DD.MM.YY hh:mm')}` )
			// md?.text( objdescriptionMd )
			
			const x = Widget.left()// + Widget.width() + 10
			const y = Widget.top() + Widget.height() + gap
			// const y = Widget.top() + Widget.height() + md_height + gap*2

			const app_height = 600
			const app_widget = Widget.map().widget_add( 'iframe', [x, y], 600, app_height )
			app_widget?.iframe().html_use( true )
			app_widget?.text( generateHtml( {
				...obj,
				// body: '<div class="root"></div>',
			} ) )
				
			const func_height = 400
			obj.getFunctions?.forEach( (f, i) => {
				const code = f[1]
				const widget_y = y + (func_height)*i + (app_height + gap*2)
				const widget = Widget.map().widget_add( 'code_js', [x, widget_y], 600, func_height )
				widget?.text( code )
				widget?.title( f[0] )
			} )
			
			// obj.renderFunctions?.forEach( (f, i) => {
			// 	const code = f[1]
			// 	const widget_y = y + (func_height+gap)*(i+obj.getFunctions.length) + (app_height + gap*2)
			// 	const widget = Widget.map().widget_add( 'code_js', [x, widget_y], 600, func_height )
			// 	widget?.text( code )
			// 	widget?.title( f[0] )
			// } )

		}
		
	}

	type AI_answer = {
		head: string
		body: string
		mainScriptBody: string
		descriptionMd: string
		getFunctions: [string, string][]
		renderFunctions: [string, string][]
	}
	
	function generateHtml( obj: AI_answer ): string {
		const { head, body, mainScriptBody } = obj
		
		return `<!DOCTYPE html>
<html lang="ru">
<head>
${head}
</head>
<body>
${body}
<script>
${mainScriptBody}
</script>
</body>
</html>`;
	}

	function createNameVersions(oldNames: string[], newNames: string[]): Record<string, number> {
		const prefixMap = new Map<string, number>();
		
		for (const oldName of oldNames) {
			const match = oldName.match(/^([a-zA-Z]+)(\d+)?$/);
			if (match) {
				const [, prefix, numStr] = match;
				const number = numStr ? parseInt(numStr) : 0;
				
				if (!prefixMap.has(prefix) || prefixMap.get(prefix)! < number) {
					prefixMap.set(prefix, number);
				}
			}
		}
		
		const versions: Record<string, number> = {};
		
		for (const newName of newNames) {
			const maxNumber = prefixMap.get(newName) || 0;
			versions[newName] = maxNumber + 1;
		}
		
		return versions;
	}

}
